import React, { useState } from "react";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import '../../sass/components/flexibleModules/_components.twoColumnSectionWithOrWithoutTabs.scss';

const TwoColumnSectionWithOrWithoutTabs = ({ data }) => {
    const tabLength = data.twoColumnSectionWithTabsRepeater.length;

    const [tabSection, setTabSection] = useState(data.twoColumnSectionWithTabsRepeater[0].tabTitle);

    const tabFilter = (tabValue) => {
        setTabSection(tabValue);
    }

    return (
        <div className="cp-flexibleTwoColumnTab l--genericpadding l--sectionPadding" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-flexibleTwoColumnTab__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {tabLength > 1 &&
                    <div className="cp-flexibleTwoColumnTab__tabs">
                        <div className="cp-flexibleTwoColumnTab__tabs-inner">
                            {data.twoColumnSectionWithTabsRepeater.map((tabSectionTitle, index) => (
                                <button className={tabSectionTitle.tabTitle === tabSection ? 'is-active' : ''} onClick={e => tabFilter(e.currentTarget.getAttribute('data-value'))} data-value={tabSectionTitle.tabTitle} key={index}>{tabSectionTitle.tabTitle}</button>
                            ))}
                        </div>
                    </div>
                }
                {data.twoColumnSectionWithTabsRepeater.map((tabSections, index) => (
                    <React.Fragment key={index}>
                        {tabSection === tabSections.tabTitle &&
                            <div className="cp-flexibleTwoColumnTab__sections" key={index}>
                                <div className="cp-flexibleTwoColumnTab__sections-top l--flex">
                                    <div className="l-twoColumnLeft">
                                        <h2 dangerouslySetInnerHTML={{ __html: tabSections.sectionTitle }} />
                                        <div dangerouslySetInnerHTML={{ __html: tabSections.sectionTeaser }} />
                                    </div>
                                    <div className="l-twoColumnRight">
                                        {tabSections.sectionImageBackground ?
                                            <div className="l-imageWithBackground" style={{ backgroundColor: `${tabSections.sectionImageBackground}` }}>
                                                {tabSections.sectionImage &&
                                                    <GatsbyImage image={getImage(tabSections.sectionImage.gatsbyImage)} alt={tabSections.sectionImage.altText} />
                                                }
                                            </div>
                                            :
                                            <>
                                                {tabSections.sectionImage &&
                                                    <GatsbyImage image={getImage(tabSections.sectionImage.gatsbyImage)} alt={tabSections.sectionImage.altText} />
                                                }
                                            </>
                                        }
                                        <div className="l--flex">
                                            {tabSections.sectionImageTeaser &&
                                                <p dangerouslySetInnerHTML={{ __html: tabSections.sectionImageTeaser }} />
                                            }
                                            {tabSections.sectionImageButton &&
                                                <a className="l-button" href={tabSections.sectionImageButton.url} target={tabSections.sectionImageButton.target}>{tabSections.sectionImageButton.title}</a>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="cp-flexibleTwoColumnTab__sections-bottom l--flex">
                                    <div className="l-CustomerStoryLeft">
                                        {tabSections.customerStoryLeftLogo &&
                                            <GatsbyImage image={getImage(tabSections.customerStoryLeftLogo.gatsbyImage)} alt={tabSections.customerStoryLeftLogo.altText} />
                                        }
                                    </div>
                                    <div className="l-CustomerStoryRight">
                                        <p dangerouslySetInnerHTML={{ __html: tabSections.customerStoryRightQuote }} />
                                        <div className="l-customerAuthor l--flex">
                                            <div className="l--flex">
                                                {tabSections.customerStoryAuthorThumb &&
                                                    <GatsbyImage image={getImage(tabSections.customerStoryAuthorThumb.gatsbyImage)} alt={tabSections.customerStoryAuthorThumb.altText} />
                                                }
                                                <div className="l-authorDetails">
                                                    <span>{tabSections.customerStoryAuthorName}</span>
                                                    <span>{tabSections.customerStoryAuthorTitle}</span>
                                                </div>
                                            </div>
                                            {tabSections.customerStoryLink &&
                                                <a className="l-textLink" href={tabSections.customerStoryLink.url} target={tabSections.customerStoryLink.target}>{tabSections.customerStoryLink.title} <StaticImage src="../../images/icon-rightArrow.svg" alt="" /></a>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
}

export default TwoColumnSectionWithOrWithoutTabs;